module.exports = __webpack_public_path__ + "files/625eef4a29808a82c608af73154c32db.png";